export const currentDate = new Date();

export const mockDateFiveDaysAgo = currentDate.setDate(
  currentDate.getDate() - 5,
);
